import RcPagination, { PaginationProps } from 'rc-pagination'
import no from 'rc-pagination/es/locale/nb_NO'
import 'rc-pagination/assets/index.css'
import './index.scss'

export function Pagination(props: PaginationProps) {
  return <RcPagination locale={no} {...props} />
}
